/*
 * @Author: Ashley.Liu
 * @Date: 2022-03-02 15:03:05
 * @LastEditTime: 2022-06-14 17:04:54
 * @Description: desc
 */
import './plugins/zoom-ui'
import router from './plugins/router'
import App from './App.vue'
import './styles/sidebar.scss'
import './styles/common.scss'
import './permission' // permission control
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import VCharts from 'v-charts'
import store from '@/store'
import debounce from 'lodash/debounce'
import './components/MultiTabs'
import VueXss from 'vue-xss'
import { getAllDicts } from '@/utils/getDicts'
import './public_path'

Vue.use(VCharts)
Vue.use(VueClipboard)

// const Vue = window.Vue
Vue.config.productionTip = false
Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 }

Vue.prototype.$eventBus = new Vue()
window.onresize = debounce(() => {
  Vue.prototype.$eventBus.$emit('window-resize')
}, 30)

Vue.use(VueXss, {
  whiteList: {
    em: []
  },
  stripIgnoreTag: false,
  stripIgnoreTagBody: ['script', 'style']
})
window.onload = () => {
  const mask = document.querySelector('.app-page-loader-mask')
  document.body.removeChild(mask)
  getAllDicts('isRefresh')
}

let instance = null
function render (props = {}) {
  const { container, autoSetLoading, setLoading } = props
  setLoading && setLoading(false)
  instance = new Vue({
    router,
    store,
    data () {
      return {
        standalone: !container,
        autoSetLoading,
        setLoading
      }
    },
    render: h => h(App)
  }).$mount(container ? container.querySelector('#app') : '#app')
  console.log(instance)
}

export async function bootstrap () {
  console.log('[vue] vue app bootstraped')
}

export async function mount (props) {
  const { setLoading } = props
  setLoading && setLoading(false)
  try {
    getAllDicts('isRefresh')
  } catch (error) {
    console.log(error)
  }

  console.log('[vue] props from main framework')
  render(props)
}

export async function unmount () {
  instance.$destroy()
  instance.$el.innerHTML = ''
  instance = null
}

if (!window.__POWERED_BY_QIANKUN__) {
  render()
}
